import { Typography, Box } from "@material-ui/core";
import PieChart from "components/PieGraph/PieGraph";
import AthleteIcon from "assets/icons/athleteIcon.svg";
import InfoIcon from "assets/icons/information.svg";

const Demographics = ({
  demographics,
  topFive,
}: {
  demographics: any[];
  topFive: any[];
}) => {
  return (
    <>
      <Typography
        variant="h4"
        style={{
          fontFamily: "Sofia Pro",
          flexWrap: "nowrap",
          display: "flex",
          fontWeight: "600",
          marginTop: "20px",
          marginBottom: "20px",
          alignItems: "center",
        }}
      >
        Demographics and Summary Stats{" "}
        <img
          src={InfoIcon}
          alt="filterTable"
          style={{ width: "25px", height: "25px", cursor: "pointer" }}
          className={`ml-2 mt-1 w-[15px] h-[15px] object-fill fill-black`}
        />
      </Typography>
      <Box sx={{ display: "flex" }}>
        <Box
          bgcolor={"#f0f0f0d5"}
          sx={{
            flexDirection: "column",
            padding: "75px",
            maxHeight: "300px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            marginRight: "20px",
          }}
        >
          <img
            aria-hidden="true"
            src={AthleteIcon}
            alt="close"
            style={{ cursor: "pointer", width: "75px", height: "75px" }}
          />
          <Typography
            style={{
              marginTop: "10px",
              marginBottom: "5px",
              fontFamily: "Sofia Pro",
              color: "#5C5D69",
            }}
            variant="h5"
          >
            Total Athletes
          </Typography>
          <Typography
            variant="h4"
            style={{
              fontFamily: "Sofia Pro",
            }}
          >
            {demographics.find((item) => item.label === "total")?.value}
          </Typography>
        </Box>
        <Box
          bgcolor={"#f0f0f0d5"}
          style={{ height: "300px", minWidth: "400px", marginRight: "20px" }}
        >
          {demographics.length ? (
            <PieChart
              isInteractive={true}
              enableArcLabels={true}
              data={demographics.filter((item) => item.label !== "total")}
            />
          ) : (
            "Loading..."
          )}
        </Box>

        <Box
          bgcolor={"#f0f0f0d5"}
          style={{
            height: "300px",
            minWidth: "565px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {topFive.length ? (
            <div
              style={{
                height: "300px",
                minWidth: "565px",
                position: "relative",
              }}
            >
              <PieChart
                isInteractive={false}
                legends={[
                  {
                    anchor: "bottom",
                    direction: "column",
                    justify: false,
                    translateX: -200,
                    translateY: -4,
                    itemsSpacing: 0,
                    itemWidth: 50,
                    itemHeight: 35,
                    itemTextColor: "#999",
                    itemDirection: "left-to-right",
                    itemOpacity: 1,
                    symbolSize: 18,
                    symbolShape: "circle",
                    effects: [
                      {
                        on: "hover",
                        style: {
                          itemTextColor: "#000",
                        },
                      },
                    ],
                  },
                ]}
                enableArcLabels={false}
                data={topFive.map((item) => ({
                  label: `${item.patient.profileInfo.firstName} ${item.patient.profileInfo.lastName}`,
                  value: 20,
                  id: `${item.patient.profileInfo.firstName} ${item.patient.profileInfo.lastName}`,
                }))}
              />
              <div
                style={{
                  position: "absolute",
                  top: "45%",
                  left: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  transform: "translate(-50%, -50%)",
                }}
              >
                <p style={{ textAlign: "center" }}>
                  Average <br /> Score
                </p>{" "}
                <strong style={{ fontSize: "20px" }}>
                  {topFive[0]?.calculations.currentAverage}{" "}
                </strong>
                <strong style={{ fontSize: "20px" }}>
                  {" "}
                  {topFive[0]?.calculations.previousAverage}
                </strong>
              </div>
            </div>
          ) : (
            "Loading..."
          )}
          {topFive.length && (
            <Box
              style={{
                marginLeft: "-160px",
                marginTop: "-40px",
                display: "flex",
                flexDirection: "column",
                fontFamily: "'SofiaPro'",
              }}
            >
              <Typography
                style={{
                  marginTop: "10px",
                  marginBottom: "5px",
                  fontFamily: "Sofia Pro",
                  color: "#5C5D69",
                }}
                variant="h5"
              >
                Biggest Improvement
              </Typography>
              <Typography
                variant="h4"
                style={{
                  fontFamily: "Sofia Pro",
                }}
              >
                {topFive[0].patient.profileInfo.firstName}{" "}
                {topFive[0].patient.profileInfo.lastName}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
export default Demographics;
